import type { ActiveRoom } from '@patrianna/shared-patrianna-types/store/BingoModule'
import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { createSelector } from '@reduxjs/toolkit'

import type { ReduxState } from 'src/store/types'

const getBingoRooms = (state: ReduxState) => state.bingo?.rooms

const getBingoProducts = (state: ReduxState) => state.bingo?.products

export const getBingoRoomsSelector = createSelector(getBingoRooms, (bingoRooms) => bingoRooms || [])

export const getBingoProductsSelector = createSelector(getBingoProducts, (bingoProducts) => bingoProducts || [])

export const getBingoProductsByCurrencySelector = createSelector(
  getBingoProductsSelector,
  (state: ReduxState, currency: string) => currency,
  (products: GameProduct[], currency) => products?.filter((i) => i?.mode === currency || i?.mode === 'gold_sweepstake'),
)

export const getBingoRoomById = createSelector(
  getBingoRoomsSelector,
  (state: ReduxState, id: string) => id,
  (allRooms: ActiveRoom[], id) => allRooms?.find((i) => i?.roomId === Number(id)),
)

export const getJackpotsRoomById = createSelector(
  getBingoRoomsSelector,
  (state: ReduxState, id: string) => id,
  (allRooms: ActiveRoom[], id) => {
    const room = allRooms?.find((i) => i?.roomId === Number(id))

    return room?.jackpots || []
  },
)

export const getBingoRoomJackpotPrize = createSelector(
  (state: ReduxState) => state.bingo?.bingoRoomsJackpots,
  (_state: ReduxState, id: string) => id,
  (bingoRoomsJackpots, id) => bingoRoomsJackpots?.[id] ?? null,
)

export const getGameJackpots = createSelector(
  (state: ReduxState) => state.bingo?.gameJackpots,
  (_state: ReduxState, gameKey: string) => gameKey,
  (gameJackpots, gameKey) => gameJackpots?.[gameKey] ?? null,
)
